import { useEffect } from "react";

import { IVimeoEvents, TPandaEvents } from "../components/Vignette/types";
import useBillboardPageContext from "./useBillboardPageContext";

const useBackgroudPlayerContent = () => {
  const {
    setBackgroundContent,
    videoTimeDuration,
    setVideoTimeDuration,
    group,
  } = useBillboardPageContext();

  const handleUpdateVideoDurationTime = (videoDurationFromEvent: number) => {
    if (!videoDurationFromEvent) return;

    const videoDurationInSeconds =
      Number(videoDurationFromEvent?.toFixed()) * 1000;

    const shouldUpdateVideoTime =
      videoDurationInSeconds !== videoTimeDuration &&
      videoDurationInSeconds > 0;

    if (shouldUpdateVideoTime) setVideoTimeDuration(videoDurationInSeconds);
  };

  useEffect(() => {
    const videoType = group?.billboard_video_type;
    if (!group) return;

    window.addEventListener(
      "message",
      (event) => {
        const { data } = event;

        const isVimeo = videoType === "vimeo";
        const pageLoadWasStoped =
          sessionStorage.getItem("page-load-stoped") === "true";

        let videoEnded = false;
        let videoDuration = null;

        if (isVimeo) {
          const vimeoVideo: IVimeoEvents = data;
          const eventMessage = vimeoVideo?.event === "timeupdate";

          videoDuration = vimeoVideo?.data?.duration;

          if (vimeoVideo?.data?.percent >= 0.995 && eventMessage)
            videoEnded = true;
        } else {
          const message: TPandaEvents = data?.message;
          if (message === "panda_ended") videoEnded = true;

          if (message === "panda_allData")
            videoDuration = data?.playerData?.duration;
        }

        const shouldReplaceVideoWithImage = pageLoadWasStoped || videoEnded;
        if (shouldReplaceVideoWithImage) setBackgroundContent("image");

        handleUpdateVideoDurationTime(videoDuration);
      },
      false,
    );

    return () => window.removeEventListener("message", () => null, false);
  }, [group]);
};

export default useBackgroudPlayerContent;
